export default __webpack_public_path__ + "static/media/kyc-verifered.c3739133.svg";